export default __webpack_public_path__ + "static/media/bg-login.2fa8d52a.png";